import { render, staticRenderFns } from "./SignUpHeader.vue?vue&type=template&id=58b67f21&scoped=true&lang=pug"
import script from "./SignUpHeader.js?vue&type=script&lang=js&external"
export * from "./SignUpHeader.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b67f21",
  null
  
)

export default component.exports